module.exports = __webpack_public_path__ + "img/login12_bak.5a47ece1.png";